import React from 'react';
export const SelectedDateContext = React.createContext();